import store from '../../store';

export default (to, from, next) => {


    let roles = store.getters['roles'];
    let isAuthenticated = store.getters['authenticated'];
    console.log("dederttffdd ",isAuthenticated);
    if (isAuthenticated) {
        if (roles.includes('suber-admin'))
            next({name: 'organization'});
        if (roles.includes('admin'))
            next({path: '/settings/user'});
    } else {
        next();
    }
}